import { Button } from '../ui/Button';

export function UserManagement() {
    const users = [
        { id: '1', email: 'alice@example.com', role: 'user', created: '2023-10-01' },
        { id: '2', email: 'bob@example.com', role: 'admin', created: '2023-09-15' },
        { id: '3', email: 'charlie@example.com', role: 'user', created: '2023-11-20' },
    ];

    return (
        <div className="bg-white p-6 rounded-xl border-2 border-zinc-200">
            <div className="flex justify-between items-center mb-6">
                <h2 className="text-2xl font-bold font-hand">Users</h2>
                <Button variant="primary" className="text-sm py-1">Add User</Button>
            </div>

            <div className="overflow-x-auto">
                <table className="w-full text-left border-collapse">
                    <thead>
                        <tr className="border-b-2 border-zinc-100">
                            <th className="p-3 font-semibold text-zinc-600">ID</th>
                            <th className="p-3 font-semibold text-zinc-600">Email</th>
                            <th className="p-3 font-semibold text-zinc-600">Role</th>
                            <th className="p-3 font-semibold text-zinc-600">Joined</th>
                            <th className="p-3 font-semibold text-zinc-600">Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                        {users.map((user) => (
                            <tr key={user.id} className="border-b border-zinc-50 hover:bg-zinc-50">
                                <td className="p-3 text-zinc-500 font-mono text-xs">{user.id}</td>
                                <td className="p-3 font-medium">{user.email}</td>
                                <td className="p-3">
                                    <span className={`px-2 py-1 rounded-full text-xs font-bold ${user.role === 'admin' ? 'bg-purple-100 text-purple-700' : 'bg-gray-100 text-gray-700'
                                        }`}>
                                        {user.role.toUpperCase()}
                                    </span>
                                </td>
                                <td className="p-3 text-zinc-500 text-sm">{user.created}</td>
                                <td className="p-3">
                                    <button className="text-blue-500 hover:underline mr-2">Edit</button>
                                    <button className="text-red-500 hover:underline">Ban</button>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
}
